import { computed, inject, Injectable, signal } from '@angular/core';

import { ProductsListService } from '@product-list';
import { BreakpointObserverService } from '@core';
import { PaginatedOffset, ProductDetailsDto, ProductSearchQueryParams } from '@models';
import { HttpClient } from '@angular/common/http';
import { ENV } from '@di-tokens';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WishlistProductsService extends ProductsListService {
  private readonly env = inject(ENV);
  private readonly http = inject(HttpClient);
  private readonly isTablet = inject(BreakpointObserverService).isTablet;

  override title = signal('Wish list');
  override subtitle = computed(() => (this.products().length ? 'All of your favorites saved in one place.' : ''));
  override productsPerPage = computed(() => (this.isTablet() ? 6 : 8));

  override getList(params: ProductSearchQueryParams): Observable<PaginatedOffset<ProductDetailsDto>> {
    const p: { count?: number; offset?: number } = {};
    if (params.count) {
      p.count = params.count;
    }
    if (params.offset) {
      p.offset = params.offset;
    }
    return this.http.get<PaginatedOffset<ProductDetailsDto>>(this.env.remoteApi + '/wishlist', {
      params: p,
    });
  }
}
